import { render, staticRenderFns } from "./ImportarMatriz.vue?vue&type=template&id=52d29bfa&scoped=true&"
import script from "./ImportarMatriz.vue?vue&type=script&lang=js&"
export * from "./ImportarMatriz.vue?vue&type=script&lang=js&"
import style0 from "./ImportarMatriz.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ImportarMatriz.vue?vue&type=style&index=1&id=52d29bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d29bfa",
  null
  
)

export default component.exports